import { render } from "./FavouritesEditForm.vue?vue&type=template&id=06b952f1&scoped=true"
import script from "./FavouritesEditForm.vue?vue&type=script&lang=js"
export * from "./FavouritesEditForm.vue?vue&type=script&lang=js"

import "./FavouritesEditForm.vue?vue&type=style&index=0&id=06b952f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b952f1"]])

export default __exports__